import { Pipe } from '@angular/core';

@Pipe({
  name: 'reverse'
})
export class ReversePipe {
  transform(value) {
    return value.slice().reverse();
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/reverse-pipe.ts